import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentVersion } from 'src/core/models/version/component-version.model';
import { VersionInfo } from 'src/core/models/version/version-info.model';
import { VersionService } from 'src/core/services/version/version.service';

@Component({
  selector: 'app-version-modal',
  standalone: true,
  imports: [CommonModule, LocalizationPipe],
  templateUrl: './version-modal.component.html',
  styleUrls: ['./version-modal.component.scss'],
})
export class VersionModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly versionService = inject(VersionService);

  versionInfo: VersionInfo | null = null;
  isLoading = true;
  showDetails = false;
  productVersion = '';

  readonly logoSrc = 'assets/images/logo/icon.svg';

  ngOnInit(): void {
    this.versionService.getVersionInfo().subscribe({
      next: info => {
        this.versionInfo = info;
        this.productVersion = info.productVersion;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  close(): void {
    this.activeModal.close();
  }

  trackByName(_index: number, comp: ComponentVersion): string {
    return comp.name;
  }
}
